import React from "react";

import useRedux from "hooks/useRedux";

import * as actionsGroupList from "./shoppingCart.duck";
import * as paymentsActionsGroupList from "../payments/stripe/stripe.duck";

import Button from "@material-ui/core/Button";

import Heading from "../home/components/Heading";
import Footer from "../home/components/Footer";
import ContentSection from "../home/components/ContentSection";
import Preview from "../portfolioEntryWizard/components/Preview";

import { getDateString } from "../helpers/dateHelpers";
import { Divider, CircularProgress } from "@material-ui/core";

import { openConfirm } from "../components/confirmBox/ConfirmBox";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import { getDollarValue, formatCurrencyForRegion } from "../helpers";
import { authHeaders, config } from "../helpers";

import StripeCheckoutForm from "./components/StripeCheckout";

import Order from "../account/components/OrderItem";

import Login from "../login/Login";

import axios from "axios";

import { hashHistory } from "browserHistory";

const Main = (props) => {
  const { match } = props;
  const [state, actions, paymentActions] = useRedux(
    actionsGroupList,
    paymentsActionsGroupList,
  );

  const shoppingCart = state.shoppingCart;
  const payments = state.stripePayments;
  const userManager = state.userManager;

  const [paymentComplete, paymentComplete_set] = React.useState(false);
  const [selectedPortfolio, selectedPortfolio_set] = React.useState(null);
  const [showCheckoutDialog, showCheckoutDialog_set] = React.useState(false);
  const [login, login_set] = React.useState(null);
  const [loadingPayment, loadingPayment_set] = React.useState(false);

  const { cart, loading } = shoppingCart;
  const { portfolios = [] } = cart;

  const { params = { sessionId: "" } } = match;
  const { sessionId } = params;

  React.useEffect(() => {
    actions.loadCart(portfolios);
  }, [portfolios.length]);

  React.useEffect(() => {
    if (!sessionId) return;

    console.log(sessionId);

    loadingPayment_set(true);

    const requestOptions = {
      method: "POST",
      headers: true ? { "Content-Type": "application/json" } : {},
      // data: JSON.stringify({ sessionId }),
      url: `${config.apiUrl}/payment/GetOrderCompletion?sessionId=${sessionId}`,
    };

    requestOptions.headers = { ...requestOptions.headers, ...authHeaders() };

    var count = 0;

    var send = () => {
      axios.request(requestOptions).then((response) => {
        if (response.data.ok === true) {
          actions.clear();
          paymentComplete_set(response.data);
          showCheckoutDialog_set(false);
          loadingPayment_set(false);

          console.log("done");
          // ok = true;
        } else {
          if (count < 10) {
            setTimeout(() => {
              count++;
              send();
            }, 5000);
          } else {
            alert(
              "Unable to retreive order. Please wait a few minutes and then check the orders in your profile or emails for access to the report.",
            );
          }
        }
      });
    };

    send();
  }, sessionId);

  // const total = shoppingCart.data && !loading ? ((shoppingCart.data.costPerPortfolio * nonFreePortfolios.length) + shoppingCart.data.totalTaxes) : 0;

  const style = {
    col1: {
      width: 600,
    },
    col2: {
      width: 100,
      textAlign: "right",
    },
    col3: {
      width: 100,
      marginLeft: 20,
    },
  };

  const isProcessing = payments.isProcessing;

  return (
    <div>
      <Heading {...props} />
      {login && (
        <Login
          onLoggedIn={(success) => {
            if (success) showCheckoutDialog_set(true);
            else {
              login_set(null);
            }
          }}
          showLogin={login === "login"}
          showCreateAccount={login === "signup"}
        />
      )}

      {selectedPortfolio && (
        <div>
          <Dialog
            open={true}
            onClose={() => {
              // viewLogin_set(false);
            }}
            maxWidth={"lg"}
            fullWidth={true}
          >
            <DialogContent>
              <Preview
                {...{
                  ...props,
                  portfolio: portfolios.find((e) => e.id === selectedPortfolio),
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                color={"primary"}
                onClick={() => {
                  selectedPortfolio_set(null);
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {isProcessing && (
        <div>
          <Dialog
            open={true}
            onClose={() => {
              // viewLogin_set(false);
            }}
            maxWidth={"xs"}
            fullWidth={true}
          >
            <DialogTitle>Processing Payment</DialogTitle>
            <DialogContent>
              <div style={{ textAlign: "center" }}>
                <CircularProgress size={68} />
              </div>
            </DialogContent>
          </Dialog>
        </div>
      )}
      {paymentComplete && (
        <div>
          <Dialog
            open={true}
            onClose={() => {
              // viewLogin_set(false);
            }}
            maxWidth={"md"}
            fullWidth={true}
          >
            <DialogTitle>Order Complete</DialogTitle>
            <DialogContent>
              <Order
                order={paymentComplete.order}
                useGuid={!userManager.user}
                fromCheckout={true}
              />
            </DialogContent>
            <DialogActions>
              {userManager.user && (
                <Button
                  color={"primary"}
                  onClick={() => {
                    hashHistory.push("/Account/Orders");
                  }}
                >
                  View Your Orders
                </Button>
              )}
              <Button
                color={"primary"}
                onClick={() => {
                  paymentComplete_set(null);
                  showCheckoutDialog_set(false);
                  hashHistory.push("/ShoppingCart");
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {sessionId && loadingPayment && (
        <div>
          <Dialog
            open={true}
            onClose={() => {}}
            maxWidth={"xs"}
            fullWidth={true}
          >
            <DialogContent>Processing...</DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
        </div>
      )}

      {showCheckoutDialog &&
        !sessionId &&
        !isProcessing &&
        !paymentComplete && (
          <div>
            <Dialog
              open={true}
              onClose={() => {
                // viewLogin_set(false);
              }}
              maxWidth={"xs"}
              fullWidth={true}
            >
              <DialogContent>
                <StripeCheckoutForm
                  {...{
                    shoppingCart,
                    paymentActions,
                    payments,
                    userManager,
                    actions,
                  }}
                  onPaymentCompleted={(data) => {
                    actions.clear();
                    paymentComplete_set(data);
                    showCheckoutDialog_set(false);
                  }}
                  onCancel={() => {
                    showCheckoutDialog_set(false);
                    paymentActions.clearPayment();
                  }}
                />
              </DialogContent>
            </Dialog>
          </div>
        )}

      <ContentSection maxWidth={800}>
        {loading && portfolios.length > 0 && <div>Loading...</div>}
        {(!loading || portfolios.length === 0) && (
          <div>
            <div style={{ fontSize: 25, marginTop: 20, marginBottom: 20 }}>
              Shopping Cart
            </div>
            {portfolios.length === 0 && (
              <div>
                <div>Your shopping cart is empty.</div>
                <div style={{ marginTop: 20 }}>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    onClick={() => {
                      hashHistory.push("/DataEntry");
                    }}
                  >
                    Create A New Portfolio
                  </Button>
                </div>
              </div>
            )}
            {portfolios.length > 0 && (
              <div style={{ margin: "0 auto" }}>
                <div
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                    marginTop: 20,
                    fontSize: 18,
                  }}
                >
                  <div style={style.col1}>Portfolio</div>
                  <div style={style.col2}>Price</div>
                  <div style={style.col3}></div>
                </div>
                <Divider />
                {portfolios.map((portfolio) => (
                  <div key={portfolio.id}>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <div style={style.col1}>
                        <div>{portfolio.name}</div>
                        <div style={{ fontSize: 12 }}>
                          ({portfolio.currencyType} portfolio)
                        </div>
                        <div
                          style={{ fontSize: 14 }}
                        >{`${getDateString(portfolio.startMonth, portfolio.startYear)} to ${getDateString(portfolio.endMonth, portfolio.endYear)}`}</div>
                        <Button
                          color="primary"
                          onClick={() => {
                            selectedPortfolio_set(portfolio.id);
                          }}
                        >
                          Review
                        </Button>
                        <Button
                          color="primary"
                          onClick={() => {
                            // editorActions.setActivePortfolio(portfolio);
                            hashHistory.push(`/DataEntry/Edit/${portfolio.id}`);
                          }}
                        >
                          Modify
                        </Button>
                      </div>
                      <div style={style.col2}>
                        {getDollarValue(shoppingCart.data.costPerPortfolio)}
                      </div>
                      <div style={style.col3}>
                        <Button
                          color={"primary"}
                          variant={"outlined"}
                          onClick={() => {
                            //openConfirm('a');
                            openConfirm({
                              title: "Confirm Deletion",
                              description:
                                "Are you sure you want to delete this portfolio?",
                              callback: () => {
                                actions.removePortfolio(portfolio);
                              },
                            });
                          }}
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                    <Divider />
                    <div></div>
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                    marginTop: 20,
                    fontSize: 14,
                  }}
                >
                  <div style={{ ...style.col1, textAlign: "right" }}>
                    Subtotal
                  </div>
                  <div style={{ ...style.col2, textAlign: "right" }}>
                    {getDollarValue(shoppingCart.data.subTotal)}
                  </div>
                  <div style={style.col3}></div>
                </div>
                {shoppingCart.data.creditsUsed > 0 && (
                  <div>
                    <div
                      style={{ display: "flex", marginTop: 5, fontSize: 14 }}
                    >
                      <div style={{ ...style.col1, textAlign: "right" }}>
                        Account Credits
                      </div>
                      <div
                        style={{
                          ...style.col2,
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        -{getDollarValue(shoppingCart.data.creditsUsed)}
                      </div>
                      <div style={style.col3}></div>
                    </div>
                    <div
                      style={{ display: "flex", marginTop: 5, fontSize: 14 }}
                    >
                      <div style={{ ...style.col1, textAlign: "right" }}>
                        Subtotal After Credits
                      </div>
                      <div
                        style={{
                          ...style.col2,
                          textAlign: "right",
                          fontWeight: "bold",
                        }}
                      >
                        {getDollarValue(
                          shoppingCart.data.subTotal -
                            shoppingCart.data.creditsUsed,
                        )}
                      </div>
                      <div style={style.col3}></div>
                    </div>
                  </div>
                )}
                {shoppingCart.data.taxItems.map((e) => (
                  <div
                    key={`ti_${e.name}`}
                    style={{
                      display: "flex",
                      fontWeight: "normal",
                      marginTop: 5,
                      fontSize: 14,
                    }}
                  >
                    <div style={{ ...style.col1, textAlign: "right" }}>
                      {e.name}
                    </div>
                    <div style={{ ...style.col2, textAlign: "right" }}>
                      {getDollarValue(e.value)}
                    </div>
                    <div style={style.col3}></div>
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                    marginTop: 5,
                    fontSize: 18,
                  }}
                >
                  <div style={{ ...style.col1, textAlign: "right" }}>Total</div>
                  <div style={{ ...style.col2, textAlign: "right" }}>
                    {getDollarValue(shoppingCart.data.total)}
                  </div>
                  <div style={style.col3}></div>
                </div>
                <div style={{ display: "flex", marginTop: 30 }}>
                  <div style={{ whiteSpace: "nowrap" }}>
                    <Button
                      variant={"outlined"}
                      color={"primary"}
                      onClick={() => {
                        hashHistory.push("/DataEntry");
                      }}
                    >
                      Create A New Portfolio
                    </Button>
                  </div>
                  <div style={{ width: "100%" }}></div>
                  <div style={{ whiteSpace: "nowrap" }}>
                    <Button
                      color={"primary"}
                      variant={"outlined"}
                      style={{
                        borderColor: "#3f51b5",
                        backgroundColor: "#3f51b5",
                        color: "white",
                        borderRadius: 20,
                      }}
                      onClick={() => {
                        if (!userManager.user) {
                          openConfirm({
                            // title: 'Not logged in',
                            description: (
                              <div>
                                <p>
                                  You are not currently logged in to an account.
                                  You can order a report without an account;
                                  however, you will not be able to manage your
                                  past orders.
                                </p>
                                <p>
                                  When your order is complete, you will be given
                                  direct link(s) to your portfolio reports that
                                  you can use to access your analyses.
                                </p>
                              </div>
                            ),
                            maxWidth: "sm",
                            isAlert: false,
                            okBtnText: "Continue",
                            callback: () => {
                              showCheckoutDialog_set(true);
                            },
                          });
                        } else {
                          showCheckoutDialog_set(true);
                        }
                      }}
                    >
                      Checkout Now
                    </Button>
                  </div>
                </div>
                <div></div>
                <div>
                  <div style={style.col3}></div>
                </div>
              </div>
            )}
          </div>
        )}
      </ContentSection>
      <Footer />
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/shoppingCart/Main.js